<template>
<ValidationObserver ref="observer">
  <form ref="edit_nota_part_form" @submit.prevent="updateNotaPart">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Edit Nota Part
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
           (Read) No. Nota Part
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field class="md-invalid">
              <label for="">(Read) Nota Part No</label>
              <md-input v-model="nota_part_no" disabled required/>
              <validation-error :errors="apiValidationErrors.nota_part_no" />
            </md-field>
        </div>

        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            (Read) Nota Part Date
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="notapartdateedit" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Nota Part Date</label>
              <md-input v-model="nota_part_datetime" disabled required/>
              <validation-error :errors="apiValidationErrors.nota_part_datetime" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            (Read) PKB No
          </label> -->
          <div class="md-layout-item md-size-100 md-small-size-100">
            <validation-provider rules="pkbnoedit" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) PKB No</label>
              <md-input type="hidden" readonly v-model="nota_part_pkb_id" />
              <md-input v-model="nota_part_pkb_no" disabled required/>
              <validation-error :errors="apiValidationErrors.nota_part_pkb_id" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            Sparepart
          </label> -->
          <div class="md-layout-item">
             <sparepart-card :sparepart="sparepart" v-if="sparepart.length != 0" ref="childPartComponent" @data="dataPart"/>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:green">Diperiksa</span>
          </label> -->
          <!-- <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="diperiksaedit" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Diperiksa</label>
              <md-select v-model="nota_part_diperiksa" required>
                <md-option v-for="option in options_sa_list" :key="option.value" :value="option.id">
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.nota_part_diperiksa" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Diperiksa</label>
              <md-input v-model="nota_part_diperiksa" disabled/>
            </md-field>
          </div>
        <!-- </div>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:green">Mengetahui</span>
          </label> -->
          <div class="md-layout-item md-size-50 md-small-size-100">
            <validation-provider rules="mengetahuiedit" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Mengetahui</label>
              <md-select v-model="nota_part_mengetahui" required>
                <md-option v-for="option in options_auto_manager_list" :key="option.value" :value="option.id">
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.nota_part_mengetahui" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-dense md-info" @click="editConfirmation">
          Update
        </md-button>
        <md-button class="md-dense" @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {extend, ValidationObserver} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import SparepartCard from "@/pages/Dashboard/Workshop/NotaPart/ComponentForm/SparepartCard.vue";

Vue.use(VueSweetalert2);

extend('pkbnoedit', {
  ...required,
  message: 'PKB No. field is required'
});
extend('diperiksaedit', {
  ...required,
  message: 'Diperiksa field is required'
});
extend('notapartdateedit', {
  ...required,
  message: 'Nota Part Date field is required'
});
extend('mengetahuiedit', {
  ...required,
  message: 'Mengetahui field is required'
});

export default {
  name: "edit-nota-part-bhn",
    
  components: {ValidationError, "sparepart-card": SparepartCard, ValidationObserver},
  mixins: [formMixin],

  data: () => ({
    nota_part_no: null,
    nota_part_datetime: null,
    nota_part_pkb_no: null,
    nota_part_pkb_id: null,
    nota_part_diperiksa: null,
    nota_part_mengetahui: null,
    nota_part_total: null,
    options_sa_list: null,
    options_auto_manager_list: null,
    sparepart:[],
  }),

  created() {
    this.getNotaPartData();
  },
  
  methods: {
    // fungsi tombol kembali ke list nota part
    backtoList() {
      this.$router.replace({ name: 'List Nota Part'})
    },

    //ambil data yang di perlukan
    async getNotaPartData(){
   
      // check apakah id di route ada
      if(this.$route.params.id){
          
        console.log(this.$route.params.id)
        //jika ada panggil data nota part berdasarkan id
        await this.$store.dispatch("workshop_nota_part/get", this.$route.params.id)
        this.nota_part = await this.$store.getters["workshop_nota_part/nota_part"]
        this.nota_part_no = this.nota_part.nota_part_no;
        this.nota_part_datetime = this.nota_part.nota_part_datetime;
        this.nota_part_pkb_id = this.nota_part.nota_part_pkb_id;
        this.nota_part_total = this.nota_part.nota_part_total;
        this.nota_part_mengetahui = this.nota_part.nota_part_mengetahui_name.id;

        //ambil data pkb berdasarkan id pkb yang ada di nota part
        await this.$store.dispatch("workshop_pkb/get",this.nota_part_pkb_id)
        var pkb = await this.$store.getters["workshop_pkb/pkb"]
        this.sparepart = pkb.pkb_part
        this.nota_part_pkb_no = pkb.pkb_no
        this.nota_part_diperiksa = pkb.pkb_service_estimate.sa_name.name
        
          //ambil list user sa
          // var query = {"filter":{role:'service_advisor',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
          // await this.$store.dispatch("users/list",query) 
          // this.options_sa_list = await this.$store.getters["users/list"]


            //ambil list user auto manager
            var query = {"filter":{role:'workshop_head',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
            await this.$store.dispatch("users/list",query)
          this.options_auto_manager_list = await this.$store.getters["users/list"]
      }
    },

    // konfirmasi edit data
    editConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.updateNotaPart(id)
        }
      });
    },

    // ubah data
    async updateNotaPart() {

      if(this.$route.params.id == null || !this.$route.params.id) {
        await this.$store.dispatch("alerts/error", "You are not allowed not change data of default users.")
        return
      }

        
      const data = {
        id: this.nota_part.id,
        type: "workshop_nota_parts",
        nota_part_no: this.nota_part_no,
        nota_part_datetime: this.nota_part_datetime,
        nota_part_pkb_id: this.nota_part_pkb_id,
        nota_part_total: this.nota_part_total,
        nota_part_mengetahui: this.nota_part_mengetahui,
        // nota_part_diperiksa: this.nota_part_diperiksa
      }
      
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_nota_part/update", data)
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Nota Part data changed successfully.")
        // kembali ke list nota part
        await this.$router.replace({name: 'List Nota Part'});
        //this.$refs['password_form'].reset()
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }

    },
     
    //set data yang diambil dari fungsi getData di child page/sparepart card
    dataPart (value) {
      this.nota_part_total = value
    },
  }
};
</script>

